export default {
  name: 'Nombre',
  selectGroups: 'Selección de grupos',
  group: 'Grupo'
}
